import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { breakpoint } from 'utils/style'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import injectTranslate from 'i18n/hoc/injectTranslate'

const BlocShadow = styled.div`
  ${breakpoint('l')`
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 0 70px #f0f0ff;
    background: white;
  `}
`

const AuthProTemplate = ({ children, title, description }) => (
  <Container>
    <Row
      hasVerticalAlign
      margin="vertical-xxl"
      smMargin="vertical-xl"
      smPadding="horizontal-sm"
    >
      <Col sm="12" md="6">
        <Title headingLevel="1">{title}</Title>
      </Col>
      <Col sm="12" md="5" offset="1">
        <BlocShadow>
          <Title headingLevel="3" margin="bottom-sm">
            {description}
          </Title>
          {children}
        </BlocShadow>
      </Col>
    </Row>
  </Container>
)

AuthProTemplate.propTypes = {
  children: PropTypes.any.isRequired,
  description: PropTypes.string,
}

export default injectTranslate(AuthProTemplate)
